import React from 'react';

import { useEffect } from 'react';
import { useBiopharmaGroupActions } from './BiopharmaGroupContext';
import BiopharmaGroupLoader from './BiopharmaGroupLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageSectionTitle from '../../Shared/UI/PageSectionTitle/components/PageSectionTitle';
import BiopharmaGroupTitle from './BiopharmaGroupTitle';
import BiopharmaGroupWebLinks from './BiopharmaGroupWebLinks';
import BiopharmaGroupExternalJobBoards from './BiopharmaGroupExternalJobBoards';
import BiopharmaGroupJobDescriptions from './BiopharmaGroupJobDescriptions';
import NewExternalJobBoardModal from './NewExternalJobBoardModal';
import UpdateExternalJobBoardModal from './UpdateExternalJobBoardModal';
import DeleteExternalJobBoardModal from './DeleteExternalJobBoardModal';
import DeleteJobDescriptionModal from './DeleteJobDescriptionModal';
import CloseJobDescriptionModal from './CloseJobDescriptionModal';
import ReopenJobDescriptionModal from './ReopenJobDescriptionModal';
import ArchiveJobDescriptionModal from './ArchiveJobDescriptionModal';
import UpdateJobDescriptionModal from './UpdateJobDescriptionModal';
import styles from './BiopharmaGroup.module.scss';

const BiopharmaGroup = ({ id }) => {
  const { initializeState } = useBiopharmaGroupActions();

  useEffect(() => {
    initializeState(id);
  }, []);

  return (
    <>
      <BiopharmaGroupLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <BiopharmaGroupTitle />
          <PageSectionTitle text={'Web Links'} />
          <BiopharmaGroupWebLinks />
          <PageSectionTitle text={'External Job Boards'} />
          <BiopharmaGroupExternalJobBoards />
          <PageSectionTitle text={'Job Descriptions'} />
          <BiopharmaGroupJobDescriptions />
        </Stack>
      </div>
      <NewExternalJobBoardModal />
      <UpdateExternalJobBoardModal />
      <DeleteExternalJobBoardModal />
      <DeleteJobDescriptionModal />
      <CloseJobDescriptionModal />
      <ReopenJobDescriptionModal />
      <ArchiveJobDescriptionModal />
      <UpdateJobDescriptionModal />
    </>
  );
};

export default BiopharmaGroup;
